import campaignsDefault from '&/static/campaigns/default';
import campaigns from '&/static/campaigns/campaigns';

export default {
  data() {
    return {
      path: 'default',
      campaign: campaignsDefault
    };
  },

  methods: {
    getImageSrcset(testimonial) {
      const images = testimonial.imageSrcset.split(',');

      return images.map((image) => `/static/campaigns/${this.path}/${image.trim()}`).join(', ');
    },

    getImageSrc(testimonial) {
      return `/static/campaigns/${this.path}/${testimonial.imageSrc}`;
    }
  },

  mounted() {
    const query = this.$route.params.campaign;

    if (campaigns[query] !== undefined) {
      this.path = query;
      this.campaign = campaigns[query];
    }
  }
};



// WEBPACK FOOTER //
// src/mixins/campaigns.js